<template>
  <v-row>
    <v-col cols="12" lg="2">
      <WebsiteWrapper @selected="selectedWebsite = $event.id" :verified="2" :plan="0" mandatory :hide="type === 'products'">
        <v-card id="part_state">
          <v-container>
            <span class="sr-title">
              {{ $t("manager.moderation.reviews.title_filter_state") }}
            </span>
            <v-radio-group v-model="filter_by" @change="generate" class="mt-2">
              <v-radio :label="$t('manager.moderation.reviews.not_moderated')" value="not_moderated" />
              <v-radio :label="$t('manager.moderation.reviews.moderated_rejected')" value="moderated_rejected" />
              <v-radio :label="$t('manager.moderation.reviews.moderated_published')" value="moderated_published" />
            </v-radio-group>
          </v-container>
        </v-card>
        <v-card id="part_data"  class="mt-4">
          <v-container>
            <span class="sr-title">
              {{ $t("manager.moderation.reviews.title_filter_data") }}
            </span>
            <v-select :prefix="$t('manager.moderation.reviews.with_gift')" :hide-details="true" v-model="filter_with_gift" @change="generate" :items="filter_select" class="mt-0 mb-0 pt-0 pb-0"></v-select>
            <v-select :prefix="$t('manager.moderation.reviews.from_order')" :hide-details="true" v-model="filter_from_order" @change="generate" :items="filter_select" class="mt-0 mb-0 pt-0 pb-0"></v-select>
            <v-select :prefix="$t('manager.moderation.reviews.locale')" :hide-details="true" v-model="filter_from_locale" @change="generate" :items="filter_select" class="mt-0 mb-0 pt-0 pb-0"></v-select>
            <v-select :prefix="$t('manager.moderation.reviews.with_solicitation')" :hide-details="true" v-model="filter_with_solicitation" @change="generate" :items="filter_select_solicitation" class="mt-0 mb-0 pt-0 pb-0"></v-select>
          </v-container>
        </v-card>
        <v-card id="part_keywords" class="mt-4">
          <v-container>
            <span class="sr-title">
              {{ $t("manager.moderation.reviews.title") }}
            </span>

            <v-radio-group v-model="search_by" class="mt-2">
              <v-radio :label="$t('manager.moderation.reviews.search_hashtag')" value="search_hashtag" />
              <v-radio :label="$t('manager.moderation.reviews.search_publications')" value="search_publications" />
              <v-radio :label="$t('manager.moderation.reviews.search_users')" value="search_users" />
              <v-radio :label="$t('manager.moderation.reviews.search_products')" value="search_products"
                v-if="type === 'products'"
              />
            </v-radio-group>
            <v-text-field v-model="search"
              :placeholder="$t('manager.moderation.reviews.search_keywords')"
              @keypress.enter="generate"
            />

            <v-btn block color="primary" :loading="isGenerating" small @click="generate">
              {{ $t("manager.moderation.reviews.generate_list") }}
            </v-btn>
          </v-container>
        </v-card>
      </WebsiteWrapper>
    </v-col>

    <v-col cols="12" lg="4">
      <List @select="fetchReview">
        <template #pagination>
          <v-pagination
            v-model="pagination.current_page"
            :length="pagination.last_page"
            :total-visible="4"
            @input="generate"
          ></v-pagination>
        </template>
      </List>
    </v-col>

    <v-col v-if="showReviewDetails" cols="12" lg="6">
      <Review :key="key('review')" :review="review" @remove="remove" @rollback="rollback"></Review>
      <Response
        :key="key('response')"
        :moderate.sync="review.moderate"
        :response="review.response"
        :review="review"
        @confidence="confidence"
        @remove="removeResponse"
        @rollback="rollback"
      ></Response>
    </v-col>
  </v-row>
</template>

<script>
import List from "./List"
import Review from "./Review"
import Response from "./Response"
import { unobservable } from "@/helpers"
import { Types } from "@/store/modules/publications"
import { Types as TypesSnackbar } from "../../../../store/modules/snackbar"
import WebsiteWrapper from "@/components/common/Form/WebsiteWrapper"

export default {
  name: "Moderation",
  components: {
    WebsiteWrapper,
    List,
    Review,
    Response,
  },
  props: {
    type: { type: String, required: true },
    visible: { type: Boolean, required: true },
  },
  data: () => ({
    isGenerating: false,
    reviews: [],
    generateRequestInformation: [],
    review: {},
    snapshotReviews: [],
    snapshotReview: {},
    selectedWebsite: null,
    websites: [],
    search: "",
    filter_by: "not_moderated",
    filter_with_gift: 'ALL',
    filter_from_order: 'ALL',
    filter_from_locale: 'ALL',
    filter_with_solicitation: 'ALL',
    search_by: "search_hashtag",
    pagination: {
      current_page: 1,
      last_page: 1,
    },
    filter_select: false,
    filter_select_solicitation: false
  }),
  created() {
    this.filter_select = [
      {
        text: this.$t('manager.moderation.reviews.filter_both'),
        value: 'ALL',
      },
      {
        text: this.$t('manager.moderation.reviews.filter_yes'),
        value: 'YES',
      },
      {
        text: this.$t('manager.moderation.reviews.filter_no'),
        value: 'NO',
      },
      {
        text: this.$t('manager.moderation.reviews.filter_undefined'),
        value: 'NULL',
      },
    ];
    this.filter_select_solicitation = [
      {
        text: this.$t('manager.moderation.reviews.filter_both'),
        value: 'ALL',
      },
      {
        text: this.$t('manager.moderation.reviews.filter_yes'),
        value: 'YES',
      },
      {
        text: this.$t('manager.moderation.reviews.filter_no'),
        value: 'NO',
      },
      {
        text: this.$t('manager.moderation.reviews.filter_marked'),
        value: 'MARKED',
      },
    ];
  },
  computed: {
    showReviewDetails() {
      return this.review.hasOwnProperty("id") && this.review.id > 0
    },
  },
  watch: {
    selectedWebsite() {
      if (this.visible) {
        this.generate()
      }
    },
    visible(value) {
      if (value) {
        this.generate()
      }
    },
  },
  methods: {
    handleError(i18n = "") {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t(i18n),
        config: { timeout: 1000 * 6, color: "error" },
      })
    },
    generate() {
      this.isGenerating = true
      const query = [
        `page=${encodeURIComponent(this.pagination.current_page)}`,
        `website=${encodeURIComponent(this.selectedWebsite)}`,
        `search=${encodeURIComponent(this.search)}`,
        `search_by=${encodeURIComponent(this.search_by)}`,
        `filter_by=${encodeURIComponent(this.filter_by)}`,
        `with_gift=${encodeURIComponent(this.filter_with_gift)}`,
        `from_order=${encodeURIComponent(this.filter_from_order)}`,
        `from_locale=${encodeURIComponent(this.filter_from_locale)}`,
        `with_solicitation=${encodeURIComponent(this.filter_with_solicitation)}`,
        `type=${encodeURIComponent(this.type)}`,
      ].join("&")

      this.$axios
        .get(`office/manager/generate/reviews/list?${query}`)
        .then(response => {
          this.$store.dispatch(Types.actions.REVIEWS, response.data.data)
          this.pagination = response.data
          this.isGenerating = false
        })
        .catch(() => {
          this.$store.dispatch(Types.actions.REVIEWS, [])
          this.isGenerating = false
        })
    },
    confidence: function(reason) {
      this.review.confidence = reason
    },
    key(name) {
      return `${name}.${this.review.id}.${this.review.database}`
    },
    fetchReview(partialReview) {
      this.review.id = 0
      this.$axios
        .get("office/manager/review", {
          params: {
            database: partialReview.database,
            id: partialReview.id,
          },
        })
        .then(response => {
          this.review = response.data
          if (this.review.response === null) {
            this.review.response = {
              message: "",
            }
          }

          this.snapshotReview = unobservable(this.review)
        })
        .catch(() => {
          this.refresh()
        })
    },
    rollback() {
      this.review = unobservable(this.snapshotReview)
    },
    remove() {
      this.reviews = this.reviews.filter(r => r.id + r.database !== this.review.id + this.review.database)
      this.review = {}
    },
    removeResponse() {
      let index = this.reviews.findIndex(r => r.id + r.database === this.review.id + this.review.database)

      this.review.moderate = 0
      this.review.response = { message: "" }
      this.reviews[index].moderate = 0
    },
  },
}
</script>
